import { Button, Popover } from "@mui/material";
import React, { useEffect, useState } from "react";
import CoreFilterButtonIcon from "../../../app/core/components/CoreFilterButtonIcon/CoreFilterButtonIcon";
import CoreInputField from "../../../app/core/components/CoreInputField/CoreInputField";
import CoreSelectObjArr from "../../../app/core/components/CoreSelect/CoreSelectObjArr";
import { STATUS_OPTIONS } from "../../../utils/constants/filters";
import { t } from "i18next";

const GestioneDocumentFilter = ({ filter, setFilter }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    if (filter.status) {
      setFilter({
        ...filter,
        status: filter.status,
      });
    } else {
      setFilter({
        ...filter,
        status: "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter.status]);

  useEffect(() => {
    if (filter.startDate) {
      setFilter({
        ...filter,
        startDate: filter.startDate,
      });
    } else {
      setFilter({
        ...filter,
        startDate: "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter.startDate]);

  useEffect(() => {
    if (filter.endDate) {
      setFilter({
        ...filter,
        endDate: filter.endDate,
      });
    } else {
      setFilter({
        ...filter,
        endDate: "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter.endDate]);

  useEffect(() => {
    handleFilter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  //POPOVER HANDLERS
  const handleOpenPopover = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  // HANLDE CHANGE
  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFilter({
      ...filter,
      [name]: value,
    });
  };

  const handleFilter = () => {
    setFilter(filter);
  };

  const handleReset = () => {
    setFilter({
      status: "",
      startDate: "",
      endDate: "",
    });
    handleClosePopover();
  };

  return (
    <div>
      <CoreFilterButtonIcon onOpen={handleOpenPopover} />

      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClosePopover}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ sx: { borderRadius: "8px", marginTop: "5px" } }}
      >
        <div className="w-[32rem] p-4">
          <form>
            <div className="flex flex-col">
              <h3 className="m-0">{t("Status")}</h3>
              <CoreSelectObjArr
                name="status"
                label="Stato"
                defaultValue=""
                items={STATUS_OPTIONS}
                value={filter.status}
                onChange={handleInputChange}
              />
            </div>
            <div className="flex flex-col">
              <h3 className="m-0">{t("TimePeriod")}</h3>
              <div className="flex space-x-4">
                <CoreInputField
                  name="startDate"
                  type="date"
                  value={filter.startDate}
                  onChange={handleInputChange}
                  className={"w-full"}
                  label={t("StartDate")}
                  focused
                  color="grey"
                />
                <CoreInputField
                  name="endDate"
                  type="date"
                  value={filter.endDate}
                  onChange={handleInputChange}
                  className={"w-full"}
                  label={t("EndDate")}
                  focused
                  color="grey"
                />
              </div>
            </div>
            <div className="flex space-x-4">
              <Button
                className="bg-red-700 text-white w-full"
                onClick={handleReset}
                sx={{ marginTop: "16px" }}
              >
                Reset
              </Button>
            </div>
          </form>
        </div>
      </Popover>
    </div>
  );
};

export default GestioneDocumentFilter;
